import {
  useModalContext,
  WSButton,
  WSButtons,
  WSCheckboxToggle,
  WSElementProps,
  WSForm,
  WSModal,
  WSTextInput
} from "@wingspanhq/fe-component-library";
import React from "react";
import * as Yup from "yup";
import { WSErrorMessage } from "../../../components/WSErrorMessage/WSErrorMessage";
import { useUpdateCollaborator } from "../../../query/payments/mutations";
import { useCollaboratorQuery } from "../../../query/payments/queries";
import { WSQueries } from "../../../query/WSQuery";

type Props = WSElementProps & { collaboratorId: string };

export const COLLABORATOR_TAX_INFO_MODAL = "COLLABORATOR_TAX_INFO_MODAL";

export const CollaboratorTaxInfoModal: React.FC<Props> = ({
  collaboratorId
}) => {
  const collaboratorQuery = useCollaboratorQuery(collaboratorId);
  const [updateCollaborator, updateCollaboratorMeta] = useUpdateCollaborator(
    collaboratorId
  );
  const { closeModal } = useModalContext();

  return (
    <WSModal
      name={COLLABORATOR_TAX_INFO_MODAL}
      size="S"
      title="Edit tax information"
    >
      <WSQueries queries={{ collaboratorQuery }}>
        {({ collaboratorQuery: { data: collaborator } }) => {
          return (
            <WSForm
              defaultValues={{
                adjustments: String(
                  collaborator.form1099Balances["2021"]?.adjustments
                ),
                issue1099: (collaborator.form1099Balances as any)["2021"]
                  ?.issue1099
              }}
              onSubmit={values => {
                updateCollaborator(
                  {
                    form1099Balances: {
                      "2021": {
                        adjustments: Number(values.adjustments),
                        issue1099: values.issue1099
                      }
                    } as any
                  },
                  {
                    onSuccess: () => {
                      closeModal(COLLABORATOR_TAX_INFO_MODAL);
                    }
                  }
                );
              }}
              validationSchema={Yup.object().shape({})}
            >
              <WSForm.Field
                mb="M"
                name="adjustments"
                label="Off Platform Adjustments"
                component={WSTextInput}
                componentProps={{
                  prefix: "$",
                  formatOptions: {
                    numeral: true,
                    numeralThousandsGroupStyle: "thousand",
                    rawValueTrimPrefix: true
                  }
                }}
              />

              <WSForm.Field
                mb="M"
                name="issue1099"
                component={WSCheckboxToggle}
                componentProps={{
                  label: "Send 1099 Filling"
                }}
              />

              <WSErrorMessage
                mb="M"
                error={updateCollaboratorMeta.error}
                contextKey="EditContact"
              />

              <WSButtons format="modal">
                <WSButton loading={updateCollaboratorMeta.isLoading}>
                  Update
                </WSButton>
                <WSButton.Tertiary
                  onClick={() => {
                    closeModal(COLLABORATOR_TAX_INFO_MODAL);
                  }}
                >
                  Cancel
                </WSButton.Tertiary>
              </WSButtons>
            </WSForm>
          );
        }}
      </WSQueries>
    </WSModal>
  );
};
